import { env } from '@cc-shopping/platform-env';

export const BASE_EMBEDS_URL = `https://embeds.nerdwallet.${
  env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod' ? 'com' : 'biz'
}`;
